import { render, staticRenderFns } from "./nshop-order-view.vue?vue&type=template&id=db08f260&scoped=true&"
import script from "./nshop-order-view.vue?vue&type=script&lang=js&"
export * from "./nshop-order-view.vue?vue&type=script&lang=js&"
import style0 from "./nshop-order-view.vue?vue&type=style&index=0&id=db08f260&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db08f260",
  null
  
)

export default component.exports